module.exports = __webpack_public_path__ + "static/media/bg2.6dee6d57.png";